<template>
  <div class="tableData" style="font-size: 10px;">
    <!-- 标题与生效日期 -->
    <div class="title" style="margin-top: 10px; font-size: 18px; font-weight: bold; text-align: center;">
      实名认证服务协议
    </div>
    <div style="margin-top: 5px; font-size: 12px; text-align: center; color: #666;">
      生效日期：2026年8月17日
    </div>

    <!-- 特别提示 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      特别提示
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      本协议由北京天下在线科技有限公司与拟在悄然声色平台内使用实名认证服务（以下简称“本服务”）的用户（以下或称 “您”）共同缔结。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      在使用本服务前，请您务必审慎并完整阅读以下内容，特别是免除或者限制悄然声色责任的条款，对您的权利进行限制的条款。限制、免责条款等其他涉及您重大权益的条款可能以加粗等形式提示您重点注意。您点击同意确认、或您使用本服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意本协议。本协议即在您与悄然声色之间产生法律效力，成为对双方均具有约束力的法律文件。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      本协议是《悄然声色用户服务协议》的不可分割的组成部分，与《悄然声色用户服务协议》具有同等法律效力。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      如您未满 18周岁，或存在其他不具备与用户行为相适应的民事行为能力的情形，请您在法定监护人（“监护人”）的陪同、指导下阅读本协议，并在确保监护人同意本协议内容后使用服务。您及您的监护人应依照法律法规规定，承担同意本协议及使用服务而导致的相应后果。
    </div>

    <!-- 第1条 定义 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第1条 定义
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>1.1 悄然声色平台：</strong>指北京天下在线科技有限公司及其关联公司（以下简称“我们”）合法拥有并运营的名称为 “悄然声色” 的网站、小程序、客户端应用程序以及我们不时提供的其他形式。“我们”应相应地进行理解。为免疑义，我们亦保留调整悄然声色平台名称的所有权利。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>1.2 悄然声色平台服务：</strong>指北京天下在线科技有限公司通过悄然声色平台为您提供商品与服务交易以及包括但不限于收藏、评论、平台活动等其他各项功能或服务，具体以悄然声色实际提供的为准。同时，北京天下在线科技有限公司有权对提供的该等功能或服务进行增加、关停或其他调整。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>1.3 悄然声色账号或账号：</strong>指用户在使用悄然声色平台时可能需要注册的账号。我们为用户提供悄然声色平台注册通道，您可通过移动电话号码或我们允许的其他方式注册悄然声色账号。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>1.4 悄然声色实名认证服务：</strong>指由悄然声色平台及/或其合作的第三方机构提供的，对您提交的身份证件信息（真实姓名、证件类型、证件号码）进行信息一致性核验，根据核验情况确定认证结果并提供认证结果的服务。本服务仅对身份信息做一致性比对，不做活体实人核验，无法识别是否为他人冒用身份信息提交认证。
    </div>

    <!-- 第2条 认证申请与审核 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第2条 认证申请与审核
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>2.1</strong> 您可以根据自身需求对您的悄然声色账号发起实名认证申请，并根据功能页面的提示提供相关信息及资料（如：真实姓名、证件类型、证件号码，具体以功能页面展示为准）。您理解并同意，不提供上述信息可能使您无法完成实名认证服务，进而不能享受完成实名认证后我们为您提供的其他功能或服务，但不影响您正常使用悄然声色平台的其他功能。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.2</strong> 您理解并同意，为完成实名认证信息核验，您授权悄然声色平台将合法收集的相关个人信息（您的姓名、证件号码）传输给我们合作的第三方机构完成信息比对核验。身份信息属于敏感个人信息，是提供本服务所必需。如您选择不提供或不同意悄然声色平台及/或其合作的第三方机构处理以上敏感个人信息的，将导致您无法正常使用实名认证服务。
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6; color: #d9534f; font-weight: bold;">
      提示：本协议项下实名认证仅校验身份信息是否匹配，无法识别实际操作人是否为身份证件本人，存在被他人冒用身份信息完成认证的客观风险。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.3</strong> 我们重视并保护您的个人信息。我们将按照本协议条款规则及《悄然声色用户隐私政策》的约定收集、使用、保存、共享您的个人信息。第三方机构仅用于完成本次核验，我们不会留存、缓存第三方返回的完整原始身份数据库数据。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.4</strong> 您声明并保证，您提供给我们的所有信息和资料的真实性、合法性、准确性和有效性，该身份信息为您本人合法持有，不存在冒用、盗用他人身份信息情形，且不侵犯任何第三方的合法权利。您在使用本认证服务时应遵守法律、行政法规、本协议和/或相关服务条款的规定。否则，我们有权视您的违规行为情节采取相应处置措施（包括但不限于限制、停止向您提供认证服务，取消/撤销您的认证身份等），由此导致或产生第三方主张的任何索赔、要求或损失、任何行政机关的处罚，均由您独立承担。如由此造成我们损失的，我们有权向您追偿。
    </div>

    <!-- 第3条 未成年人保护 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第3条 未成年人保护
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>3.1</strong> 若您是未满18周岁的未成年人，您应在监护人指导下认真阅读本协议，经您的监护人同意本协议后，方可使用本服务。若您未取得监护人的同意，监护人可以通过平台公示渠道通知我们处理相关账号，我们有权对相关账号的功能进行限制。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>3.2</strong> 我们重视对未成年人个人信息及隐私的保护。我们特别提醒您在填写未成年人个人信息时应加强保护意识并谨慎对待，并在监护人指导时正确使用本服务。如相关内容侵犯未成年人权利，我们在收到权利人通知或基于其他保障未成年人合法权益的考虑，有权处理相关内容并视情况通知您。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>3.3 监护人特别提示：</strong>如您的被监护人使用本服务的，您作为监护人应指导并监督被监护人的注册和使用行为。如您的被监护人使用本服务，我们有权认为其已取得您的同意。
    </div>

    <!-- 第4条 法律责任 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第4条 法律责任
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.1</strong> 您有义务保持您向我们提供的信息和资料的真实性、合法性、准确性和有效性，保证提交的是本人身份信息，不得伪造、盗用、冒用他人身份信息。如果我们有合理理由认为您提交伪造信息/证件/身份或冒用他人信息/证件/身份，或您的行为违反或可能违反上述约定的，或您违反本协议约定，我们有权视您的违规行为情节采取相应处置措施（包括但不限于限制、停止向您提供认证服务，取消/撤销您的认证身份，限制账号功能，临时或永久封禁账号，注销账号，禁止重新注册等），您应对与该等措施相关的任何损失和损害（包括但不限于您账号的认证身份、内容、虚拟财产和权限清空、无法正常使用账号及相关悄然声色平台服务或任何其他后果）承担全部责任和义务。如由此导致或产生第三方主张的任何索赔、要求或损失、任何行政机关的处罚，均由您独立承担。如由此造成我们损失的，我们有权向您追偿。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>4.2</strong> 我们尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。如您侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益，引起第三方投诉、举报或以诉讼等方式维权索赔的，我们有权根据法律法规要求采取必要措施。因您的行为导致我们向任何第三方承担赔偿责任，或遭受国家机关处罚，或受到其他经济损失或商誉损失的，您应赔偿我们因此遭受的全部损失。您承担法律责任的形式包括但不限于：对受到侵害者充分赔偿损失、赔礼道歉、补救负面影响、返还财产等。如您的行为给我们造成损失的，您应承担全部赔偿责任，包括行政处罚或损害赔偿款等直接损失以及商誉损失、和解款、律师费、诉讼费等间接损失。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>4.3</strong> 如您对本服务有任何疑问、投诉、意见和建议等，请前往【我】--【联系客服】，联系官方客服，悄然声色会及时响应和处理。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>4.4</strong> 本协议未尽事宜，以《悄然声色用户服务协议》约定为准。
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isLoading: true
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  color: #333;
  background-color: #ffffff;
}
li {
  list-style: none;
  padding: 0.5em 0;
  width: 100%;
}
.tableData {
  width: 100%;
  overflow: auto;
  padding: 10px 15px;
}
table {
  border-collapse: collapse;
  width: 600px;
}
table,
table tr th,
table tr td {
  white-space: nowrap;
}
th,
td {
  padding: 0.5em;
}
#app {
  font-family: -apple-system-font, BlinkMacSystemFont, "Helvetica Neue",
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei",
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.8em;
}
.right {
  text-align: right;
}
.middle {
  text-align: center;
}
p {
  line-height: 1.6em;
  word-break: break-all;
  padding: 0.4em 0;
}
h3,
h4 {
  padding: 0.6em 0;
  margin-bottom: 0.5em;
}
.layout {
  padding: 1em 4%;
  letter-spacing: 1px;
}
.title {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 1em;
  text-align: center;
}
.sub_list > * {
  padding: 0.6em 0;
}
</style>